// AdminDashboard.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, CircularProgress, Alert } from '@mui/material';
import OrganizationsTable from './organization/OrganizationsTable';
import FilteredUsersManagement from './organization/FilteredUsersManagement';
import ProjectsStats from './organization/ProjectsStats';
import PlansManagement from './organization/PlansManagement';
import TermsAndCondtion from './organization/TermsAndCondtion';
import StyledTab from './common/StyledTab';
import Layout from './Layout';
const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [organizations, setOrganizations] = useState([]);
  const [loadingOrgs, setLoadingOrgs] = useState(true);
  const [errorOrgs, setErrorOrgs] = useState(null);
  const [selectedOrgForFilter, setSelectedOrgForFilter] = useState('');

  // Fetch organizations to populate the organizations table
  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoadingOrgs(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/organizations`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } }
        );
        if (!response.ok) throw new Error('Failed to fetch organizations');
        const data = await response.json();
        setOrganizations(data.organizations || []);
      } catch (err) {
        setErrorOrgs(err.message);
      } finally {
        setLoadingOrgs(false);
      }
    };
    fetchOrganizations();
  }, []);

  // Handle clicking on an organization row:
  // Set the filter and switch to the Users tab (tab index 1)
  const handleOrgRowClick = (orgId) => {
    setSelectedOrgForFilter(orgId);
    setActiveTab(1);
  };

  if (loadingOrgs) return <CircularProgress />;
  if (errorOrgs) return <Alert severity="error">{errorOrgs}</Alert>;

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>
        <Tabs
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          aria-label="Admin Dashboard Tabs"
          sx={{
            marginBottom: 3,
            '& .MuiTabs-indicator': {
              height: '3px',
            backgroundColor: '#1976d2', // Indicator color
            },
          }}
        >
        <StyledTab label="Organizations" active={activeTab === 0}  />
        <StyledTab label="Users" active={activeTab === 1}  />
        <StyledTab label="Projects" active={activeTab === 2}  />
          <StyledTab label="Plans" active={activeTab === 3} />
          <StyledTab label="Company Details" active={activeTab === 4} />
        </Tabs>
        {activeTab === 0 && (
          <OrganizationsTable
            organizations={organizations}
            onRowClick={handleOrgRowClick}
          />
        )}
        {activeTab === 1 && (
          <FilteredUsersManagement initialOrgFilter={selectedOrgForFilter} />
        )}
        {activeTab === 2 && <ProjectsStats />}
        {activeTab === 3 && <PlansManagement />}
        {activeTab === 4 && <TermsAndCondtion />}
      </Box>
    </Layout>
  );
};

export default AdminDashboard;
